import { isArray } from "lodash-es";
import { useMemo } from "react";
import { FixturesFilterTypes } from "../types";

export const useFilterFixtures = (serverFixtures: any[], currentFilter: any) => {
  return useMemo(() => {
    let data = serverFixtures || [];

    Object.keys(currentFilter).forEach((filterKey: string) => {
      const filterType = FixturesFilterTypes[filterKey as keyof typeof FixturesFilterTypes];
      if (!currentFilter[filterKey] || (isArray(currentFilter[filterKey]) && !currentFilter[filterKey].length)) return;

      const currentFilterValues = isArray(currentFilter[filterKey])
        ? currentFilter[filterKey].map((x) => x.value)
        : currentFilter[filterKey];
      if (filterType === FixturesFilterTypes.HomeCompetitors) {
        data = data.filter(
          (fixture: any) =>
            fixture.competitors.some(
              (competitor: any) => competitor.isHome === true && currentFilterValues.includes(competitor.entityId),
            ) ||
            (currentFilterValues.includes("") && !fixture.competitors.some((competitor: any) => competitor.isHome === true)),
        );
      }

      if (filterType === FixturesFilterTypes.AwayCompetitors) {
        data = data.filter(
          (fixture: any) =>
            fixture.competitors.some(
              (competitor: any) => competitor.isHome === false && currentFilterValues.includes(competitor.entityId),
            ) ||
            (currentFilterValues.includes("") && !fixture.competitors.some((competitor: any) => competitor.isHome === false)),
        );
      }

      if (filterType === FixturesFilterTypes.HomeParticipants) {
        data = data.filter(
          (fixture: any) =>
            fixture.participants.some(
              (participant: any) => participant.isHome === true && currentFilterValues.includes(participant.personId),
            ) ||
            (currentFilterValues.includes("") && !fixture.participants.some((participant: any) => participant.isHome === true)),
        );
      }
      if (filterType === FixturesFilterTypes.Competitors) {
        data = data.filter(
          (fixture: any) =>
            fixture.competitors.some((competitor: any) => currentFilterValues.includes(competitor.entityId)) ||
            (currentFilterValues.includes("") && !(fixture.competitors?.length > 0)),
        );
      }

      if (filterType === FixturesFilterTypes.Participants) {
        data = data.filter(
          (fixture: any) =>
            fixture.participants.some((participant: any) => currentFilterValues.includes(participant.personId)) ||
            (currentFilterValues.includes("") && !(fixture.participants?.length > 0)),
        );
      }

      if (filterType === FixturesFilterTypes.AwayParticipants) {
        data = data.filter(
          (fixture: any) =>
            fixture.participants.some(
              (participant: any) => participant.isHome === false && currentFilterValues.includes(participant.personId),
            ) ||
            (currentFilterValues.includes("") && !fixture.participants.some((participant: any) => participant.isHome === false)),
        );
      }

      if (filterType === FixturesFilterTypes.RoundNumber) {
        data = data.filter((fixture: any) => currentFilterValues.includes(fixture.roundNumber ?? ""));
      }

      if (filterType === FixturesFilterTypes.Venues) {
        data = data.filter((fixture: any) => currentFilterValues.includes(fixture.venueId ?? ""));
      }

      if (filterType === FixturesFilterTypes.StartDates) {
        data = data.filter((fixture: any) => currentFilterValues.includes(fixture.startTimeLocal?.split("T")[0] ?? ""));
      }
      if (filterType === FixturesFilterTypes.DateRange) {
        const startDate = currentFilterValues.from;
        const endDate = currentFilterValues.to;

        data = data.filter((fixture: any) => {
          const fixtureDate = fixture.startTimeLocal?.split("T")[0];
          if (!fixtureDate) return false;

          const isAfterOrOnStart = !startDate || fixtureDate >= startDate.format("YYYY-MM-DD");
          const isBeforeOrOnEnd = !endDate || fixtureDate <= endDate.format("YYYY-MM-DD");

          return isAfterOrOnStart && isBeforeOrOnEnd;
        });
      }

      if (filterType === FixturesFilterTypes.FixtureTypes) {
        data = data.filter((fixture: any) => currentFilterValues.includes(fixture.fixtureType ?? ""));
      }

      if (filterType === FixturesFilterTypes.FixtureStatuses) {
        data = data.filter((fixture: any) => currentFilterValues.includes(fixture.status ?? ""));
      }

      if (filterType === FixturesFilterTypes.Stages) {
        data = data.filter((fixture: any) => currentFilterValues.includes(fixture.stageCode ?? ""));
      }

      if (filterType === FixturesFilterTypes.Pools) {
        data = data.filter((fixture: any) => currentFilterValues.includes(fixture.poolCode ?? ""));
      }

      if (filterType === FixturesFilterTypes.Series) {
        data = data.filter((fixture: any) => currentFilterValues.includes(fixture.seriesCode ?? ""));
      }
    });

    return data;
  }, [serverFixtures, currentFilter]);
};
